module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-container flex-start"
  }, [_h('div', {
    staticClass: "card two-times"
  }, [_vm._m(0), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('H5', [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  }), _h('span', {
    staticClass: "text-bold"
  }, [_vm._s(_vm.current.title)])]), " ", _h('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.current.body)
    }
  })])]), " ", _h('div', {
    staticClass: "card"
  }, [_vm._m(1), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('ul', {
    staticStyle: {
      "list-style": "none"
    }
  }, [_vm._l((_vm.contents), function(content, index) {
    return _h('li', [_h('a', {
      staticStyle: {
        "text-decoration": "none",
        "cursor": "pointer"
      },
      domProps: {
        "innerHTML": _vm._s(content.sub)
      },
      on: {
        "click": function($event) {
          _vm.showItem(index)
        }
      }
    })])
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["今月のつぼ"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["アーカイブ"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cc4c8b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/PressurePoint.vue
// module id = 434
// module chunks = 0